import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate, componentVM } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
@Component({
    selector: 'cy-dotext-box-no-cache',
    templateUrl: './dotext-box-no-cache.component.html',
    styleUrls: ['./dotext-box-no-cache.component.css']
})
export class DOTextBoxNoCacheComponent implements OnInit {

    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() customParameters: any
    private _docData: NJDocData;
    @Input() set DocData(doData: NJDocData) {
        this._docData = doData;
        this.txtDocData = this.DocData;
        this.txtValue = this._docData.dataValue;
    }
    get DocData(): NJDocData {
        return this._docData;
    }
    @Input() public loaderKey: string;
    @Input() isValid: boolean;
    @Input() RowSelected: any;
    //@Input() isEnabled: boolean;
    private _isEnabled: boolean = true;
    @Input() public set isEnabled(t: boolean) {
        this._isEnabled = t;
    }
    public get isEnabled(): boolean {
        return this._isEnabled;
    }
    @Input() isPopUpYesNo: string = "Neither";
    //Keep API from firing if not needed.
    @Input() public ignorLabel: boolean = false;
    isLoading: boolean = false;
    //use for zip code field
    @Input() public hasEvent: boolean = false;
    //used to avoid race condition caused by onblur updating loader. Caller will reset hasEvent before update completed.
    // fireEventBefore and fireEventAfter fires before and after
    // fireEventBefore only before
    // hasEvent only after
    localhasEvent: boolean
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tbDblClick: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> = new EventEmitter<componentVM>();
    @Output() textBoxAfterViewInit: EventEmitter<DOTextBoxNoCacheComponent> = new EventEmitter<DOTextBoxNoCacheComponent>();

    txtDocDefTemplate: NJDocDefTemplate
    txtDocData: NJDocData
    errorMessage: string;
    StylesText: any;
    TextBoxStyle: any;
    TextBoxStyles: any;
    TextBoxClasses: any;
    rows: string = "4";

    textAreaHeight: string = "";
    showTestText: number = 0;  
    boolUseTestText: boolean = false;
    MaxLength: string = "8000"
    tabEventSent: boolean = false;
    public isHidden: boolean = false;
    public shouldSaveBeforeContinuing: boolean = false;
    public hasSavedSoContinue: boolean = false;

    @ViewChild("TestText") TestTextElem: ElementRef;

    LabelStylesText: any
    public isDirty: boolean = false
    isReadOnly: boolean = false;
    private onKeydownKey: any;

    constructor(private data: DocDefPrimLibService, private element: ElementRef, private changeDetectorRef: ChangeDetectorRef) { }
    get txtValue(): string {
        if (this.customParameters.ValueToBlank != null) {
            if (this.txtDocData.dataValue == this.customParameters.ValueToBlank)
                this.txtDocData.dataValue = "";
        }
        if (this.customParameters.Textarea) {
            if (this.showTestText <= 1 || !this.boolUseTestText)
                this.setTextHeight();
            this.adjust();
        }
        return this.txtDocData.dataValue;
    }
    set txtValue(TxtValue: string) {
        if (!this.isLoading) {
            if (this.txtDocData.dataValue != TxtValue) {
                this.txtDocData.dataValue = TxtValue;
                if (this.customParameters.isPhone != null) {
                    TxtValue = this.fmtPhone(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                if (this.customParameters.isSSN != null) {
                    TxtValue = this.fmtSSN(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                if (this.customParameters.isNumeric != null) {
                    TxtValue = this.NumericOnly(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                this.isDirty = true;
            }
        }
    }
    onKeydown(event) {
        this.shouldSaveBeforeContinuing = true;
        this.hasSavedSoContinue = false;
        if (this.hasEvent) {
            this.isDirty = true;
            this.onKeydownKey = event.key;
            this.onBlurText();
        }
    }
    private fmtSSN(value): string {
        var val = value.replace(/\D/g, '');
        val = val.replace(/^(\d{3})/, '$1-');
        val = val.replace(/-(\d{2})/, '-$1-');
        val = val.replace(/(\d)-(\d{4}).*/, '$1-$2');
        return val == "" ? value : val;
    }
    private fmtPhone(value): string {
        var lenDiff = value.length;
        var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
        if (lenDiff - value.length > 0) {
            value = new String(value);
        }
        return value;
    }
    private NumericOnly(value): string {
        var lenDiff = value.length;
        value = value.replace(/\D+/g, '');
        //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
        if (lenDiff - value.length > 0) {
            value = new String(value);
        }
        return value;
    }

    //setTextHeight Adjust the height of the INvisible textarea
    setTextHeight(): void {
        
    }
    //Adjust the height of the visible textarea
    adjust(): void {
        
        if (this.customParameters['Textarea'] != null) 
        {
            if (this.customParameters['rows'])
            {
                this.rows = this.customParameters['rows'];
            }
            else
            {
                const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
                if (textArea.scrollHeight > 0)
                {
                    if (this.customParameters['MaxHeight'] != null)
                    {
                        textArea.style.height = this.customParameters['MaxHeight'];
                        textArea.resize = 'none';
                    }
                    else
                    {
                        textArea.style.height = 'auto';
                        textArea.style.overflow = 'hidden';
                    }
                    textArea.style.height = textArea.scrollHeight + 'px';
                }
            }
        }
    }
    getId(): string {
        let id: string = "";
        if (this.customParameters.Textarea != null)
            if (this.DocData.docDefDataRowID)
                id = this.DocDefTemplate.templateCode + this.DocData.docDefDataRowID.toString();
            else
                id = this.DocDefTemplate.templateCode;
        return id;
    }
    
    onBlurText() {
        //this.changeDetectorRef.detectChanges();
        if (this.customParameters.fireEventBefore) {
            this.localhasEvent = false;
            if (this.hasEvent) {
                let DOMessage: DOData = new DOData();
                DOMessage.njDocData = this.DocData;
                this.DocDefTemplate.indent = this.onKeydownKey;
                DOMessage.njDocDefTemplate = this.DocDefTemplate;
                this.onKeydownKey = "";
                this.clickBut.emit(DOMessage);
            }
        } else {
            this.localhasEvent = this.hasEvent;
        }
        if (this.isPopUpYesNo == "Yes")
            this.isDirty = false;
        if (!this.isLoading && this.isDirty) {           
            let lstDocData: DocdefDataVM = new DocdefDataVM();
            lstDocData.docdata.push(this.txtDocData);
            lstDocData.loaderKey = this.loaderKey;
            var _this = this;
            
        }
        if (this.hasEvent) {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.DocData;
            this.DocDefTemplate.indent = this.onKeydownKey;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            this.onKeydownKey = "";
            this.clickBut.emit(DOMessage);
        }
    }
    
    ngOnInit() {
        this.txtDocDefTemplate = this.DocDefTemplate;
        this.txtDocData = this.DocData;
        this.txtValue = this.txtDocData.dataValue;

        if (this.customParameters.isSSN != null) {
            this.MaxLength = "11";
        }


        this.tabEventSent = false;
        if (this.customParameters['isEnabled'] == 'False')
            this.isEnabled = false;
        this.setHiddenStatus();
    }
    getTextStyle(): object {
        if (this.customParameters['TextBoxStyle'] != null) {
            let styles = this.data.replaceAll(this.customParameters['TextBoxStyle'], "'", '"');
            this.TextBoxStyle = JSON.parse(styles);
            if (this.isValid)
                if (this.RowSelected) {
                    if (this.RowSelected['background-color'] == "lightsteelblue") {
                        this.TextBoxStyle['background-color'] = "lightsteelblue";
                        return this.TextBoxStyle;
                    }
                }
                else if (this.isReadOnly == true) {
                    this.TextBoxStyle['background-color'] = "white";
                    return this.TextBoxStyle;
                }
                else {
                    return this.TextBoxStyle;
                }
            else {
                this.TextBoxStyle['background-color'] = "lightpink";
                return this.TextBoxStyle;
            }
        }
        else {
            if (this.isValid)
                return null
            else
                return { "background-color": "lightpink" };
        }
    }
    ngOnChanges(): void {
        this.isLoading = true;
        this.txtDocDefTemplate = this.DocDefTemplate;
        this.txtDocData = this.DocData

        if (this.customParameters.isPhone != null) {
            this.txtDocData.dataValue = this.fmtPhone(this.txtDocData.dataValue);
        }
        if (this.customParameters.isSSN != null) {
            this.txtDocData.dataValue = this.fmtSSN(this.txtDocData.dataValue);
        }

        this.txtValue = this.txtDocData.dataValue;


        if (this.customParameters['TextValue'] != null) {
            this.isLoading = false;
            this.txtDocData.dataValue = this.customParameters['TextValue'];
            this.txtValue = this.txtDocData.dataValue;
        }
        this.isLoading = false;
        if (this.customParameters['StylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StylesText'], "'", '"');
            if (styles)
                this.StylesText = JSON.parse(styles);
        }
        if (this.customParameters['TextBoxStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['TextBoxStyles'], "'", '"');
            if (styles)
                this.TextBoxStyles = JSON.parse(styles);
        }
        if (this.customParameters['TextBoxClasses'] != null) {
            let classes = this.data.replaceAll(this.customParameters['TextBoxClasses'], "'", '"');
            if (classes)
                this.TextBoxClasses = JSON.parse(classes);
        }
        if (this.customParameters['LabelStylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
            if (styles)
                this.LabelStylesText = JSON.parse(styles);
        }
        if (this.customParameters['maxLength'] != null)
            this.MaxLength = this.customParameters['maxLength'];
        // for grids allow edit in popup.
        if (this.isPopUpYesNo == "No")
            this.isReadOnly = true;
        this.setReadonlyStatus();
        if (this.customParameters['testText'] == 'No')
            this.boolUseTestText = false;
        else
            this.boolUseTestText = true;
        //if (!this.customParameters.Textarea)
        //    this.showTestText = 99;
        if (this.customParameters['Tab'] && !this.tabEventSent) {
            let message: componentVM = new componentVM();
            message.thisComponent = this;
            message.tag = this.customParameters['Tab']
            this.tabEvent.emit(message);
            this.tabEventSent = true;
        }
        if (this.customParameters['hasEvent'] == 'Yes')
            this.hasEvent = true;
    }
    StackLabelNo() {
        if (this.customParameters['StackLabel'] == 'No')
            return "form-inline";
        else
            if (this.customParameters['StackLabel'] == null && this.customParameters['FormGroupItem'] == 'Yes')
                return "form-group flex-nowrap";
            else
                return "";
    }
    classFromParams() {
        let ret: string = "";
        if (this.customParameters.DisabledStyle == 'Yes') {
            ret = "input-block-level";
        }
        else if (this.customParameters.DisabledStyle == 'No') {
            ret = "input-block-level-white";
        }
        if (this.customParameters['InputClass'] != null) {
            ret = ret + " " + this.customParameters['InputClass'];//form-control-range
        }
        return ret;
    }

    labelWidth(): string {
        if (this.customParameters['LabelWidth'] == null) {
            if (this.customParameters['StackLabel'] == 'Yes')
                return "col-md-12 col-sm-12";
            else
                return "col-md-6 col-sm-6";
        } else {
            return this.customParameters['LabelWidth'];
        }
    }
    inputWidth(): string {
        if (this.customParameters['InputWidth'] == null) {
            if (this.txtDocDefTemplate.tLabel.length <= 0 || this.ignorLabel)
                return "col-md-12 col-sm-12"
            else
                if (this.customParameters['StackLabel'] == 'Yes')
                    return "col-md-12 col-sm-12";
                else
                    if (this.customParameters['FormGroupItem'] == null)
                        return "col-md-6 col-sm-6";
                    else
                        return "";
        } else {
            return this.customParameters['InputWidth'];
        }
    }
    // notify parent that doubleClick ocurred on this item
    public onTbDblClick() {
        let item: DOData = new DOData();
        item.njDocData = this.DocData;
        item.njDocDefTemplate = this.DocDefTemplate;
        this.tbDblClick.emit(item);
    }
    setFocus() {
        let element: any = null;
        if (this.customParameters.Textarea) {
            element = this.element.nativeElement.getElementsByTagName('textarea')[0];
        } else {
            element = this.element.nativeElement.getElementsByTagName('input')[0];
        }
        if (element)
            element.focus();
        else
            console.log('Set focus: Element undefined in: ' + this.DocDefTemplate.templateCode);
    }
    clearTextbox() {
        this.txtDocData.dataValue = "";
        this.isDirty = true;
        this.onBlurText();
    }
    setTextToValue(value : string) {
        this.txtDocData.dataValue = value;
        this.isDirty = true;
        this.onBlurText();
    }
    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isHidden = false;
            //    }
            //    else {
            //        this.isHidden = true;
            //    }
        }
        else this.isHidden = false;
    }

    setReadonlyStatus() {
        if (this.customParameters.isReadOnly == 'Yes')
            this.isReadOnly = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["DisabledIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["DisabledIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isReadOnly = false;
            //    }
            //    else {
            //        this.isReadOnly = true;
            //    }

        }
        else this.isReadOnly = false;
    }

    ngAfterViewInit() {
        this.textBoxAfterViewInit.emit(this);
    }
}
